import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../models/pipeline/steps/dataset';
import {FEATURE_FLAGS} from '../../../../services/feature_flags';
import DatasourceModel from '../../../../models/datasource';
import {
    inputBlurEvent,
} from '../../../../services/query_builder_events';
import stopEvent from '../../../../utils/stop_event';
import CombinedGroup from './dataset_attributes/combined/combined_group';
import FiltersGroup from './dataset_attributes/filters/filters';

export default class QueryBuilderHybrid extends Component {
    inputRefs = {
        columns: React.createRef(),
        filters: React.createRef(),
    };
    queryBuilderRef = React.createRef();

    constructor(props) {
        super(props);
        this.removeAttribute = this.removeAttribute.bind(this);
    }

    componentDidMount() {
        if (FEATURE_FLAGS.FOCUS_COLUMN_INPUT_ON_LOAD) {
            this.inputRefs.measures.current.attributeRefs[0].focusColumnInput();
        }
    }

    removeAttribute(attribute) {
        this.props.onRemove(attribute);
        inputBlurEvent.emit();
    }

    shouldShowFilters() {
        const {dataset: {columns, filters}} = this.props;
        return columns.length || filters.length;
    }

    render() {
        const {dataset, onClick} = this.props;

        return (
            <div
                className="query-builder-container"
                onClick={onClick}
                ref={this.queryBuilderRef}
            >
                <div
                    className="input-container"
                    onClick={onClick}
                >

                    <CombinedGroup
                        dataset={dataset}
                        attributes={dataset.columns}
                        onRemove={this.removeAttribute}
                        ref={this.inputRefs.columns}
                    />
                </div>

                {this.shouldShowFilters() ?
                    (
                        <>
                            <label className="label dataset-label-filters">FILTERS</label>
                            <div
                                className="input-container"
                                onClick={stopEvent((ev) => { onClick(ev); })}
                            >
                                <FiltersGroup
                                    dataset={dataset}
                                    attributes={dataset.filters}
                                    onRemove={this.removeAttribute}
                                    ref={this.inputRefs.filters}
                                />
                            </div>
                        </>
                    ) : null
                }
            </div>
        );
    }
}

QueryBuilderHybrid.propTypes = {
    datasource: PropTypes.instanceOf(DatasourceModel).isRequired,
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
};
